import { observable, runInAction, action, reaction } from 'mobx'
import { fromPromise } from 'mobx-utils'
import commonStore from './commonStore'
import favoritesStore from './favoritesStore'
import errorStore from './errorStore'
import api from '../api'

class UserStore {

  @observable currentUser = undefined
  @observable mediaCodeType = undefined

  @observable loadingUser = false
  @observable updatingUser = false
  @observable userLoaded = false
  @observable resendedConfirmationEmail = false


  @observable transactions = []
  @observable loadingTransactions = false

  @observable payoffs = []
  @observable loadingPayoffs = false

  @observable updatingUserErrors

  constructor() {
    if(commonStore.token) {
      this.fetchUser()
      this.fetchMediaCodeType()
    }

    reaction(
      () => this.currentUser,
      (currentUser) => {
        this.fetchTransactions()
        this.fetchPayoffs()
        favoritesStore.fetchFavoriteCategories()
      },
      {
        equals: (prev, current) => this.currentUser === undefined,
        name: 'fetch transactions, favorites, and payoffs'
      }
    )

  }

  @action.bound fetchMediaCodeType() {
    return fromPromise(api.User.getMediaCodeType()
      .then( mediaCodeType => {
        if(!!mediaCodeType) return mediaCodeType
        return Promise.reject()
      })
      .then(action('fetch user', ( mediaCodeType ) => { this.mediaCodeType = mediaCodeType.type })))
  }

  @action.bound fetchUser() {
    this.loadingUser = true
    return fromPromise(api.User.getCustomer()
      .then( user => {
        if(!!user) return user
        return Promise.reject()
      })
      .then(action('fetch user', ( user ) => { this.currentUser = user }))
      .finally(action('fetch user completed',() => this.loadingUser = false)))
  }

  @action fetchTransactions() {
    this.loadingTransactions = true
    return api.User.getTransactions()
      .then(action(( transactions ) => { this.transactions = transactions }))
      .finally(action(() => { this.loadingTransactions = false }))
  }

  @action fetchPayoffs() {
    this.loadingPayoffs = true
    return api.User.getPayoffs()
      .then(action(( payoffs ) => { this.payoffs = payoffs }))
      .finally(action(() => { this.loadingPayoffs = false }))
  }

  //WIP
  @action updateUser(newUser) {
    this.updatingUser = true
    return api.Auth.save(newUser)
      .then(action(( user ) => { this.currentUser = user }))
      .finally(action(() => { this.updatingUser = false }))
  }

  @action forgetUser() {
    this.currentUser = undefined
  }

  @action.bound calculateCompletion() {
    if (!this.currentUser || !this.currentUser.crm_customer) {
      return 0
    }

    const elements = [
      this.currentUser.crm_customer.city,
      this.currentUser.crm_customer.country,
      this.currentUser.crm_customer.dateOfBirth,
      this.currentUser.crm_customer.email,
      this.currentUser.crm_customer.firstname,
      this.currentUser.crm_customer.lastname,
      this.currentUser.crm_customer.phoneFixed,
      this.currentUser.crm_customer.phoneMobile,
      this.currentUser.crm_customer.postcode,
      this.currentUser.crm_customer.salutation,
      this.currentUser.crm_customer.street
    ]

    return Math.round((elements.filter(element => !!element).length * 100) / elements.length)
  }

  @action.bound emailIsPending() {
    return this.currentUser && this.currentUser.crm_customer && this.currentUser.crm_customer.confirmationStatus === 'pending'
  }

  @action.bound async resendConfirmationEmail() {
    if(this.emailIsPending()) {
      try {
        await api.User.resendConfirmationEmail(this.currentUser.crm_customer.confirmationId)
        runInAction('resend confirmation email', () => {
          this.resendedConfirmationEmail = true
        })
      } catch(error) {
        errorStore.displayError(error.message)
      }
    }
  }

  @action.bound resetResendedConfirmationEmail() {
    this.resendedConfirmationEmail = false
  }

  @action.bound getResendedConfirmationEmail() {
    return this.resendedConfirmationEmail
  }
}

export default new UserStore()



// WEBPACK FOOTER //
// ./src/stores/userStore.js